import { Button } from '~/components/component-library'

export const StepButtons = ({
  isDisabled,
  isLoading,
  isLastStep,
  onBackClick,
  onNextClick,
  disabledReason,
  nextButtonText,
}: {
  isDisabled?: boolean
  isLoading?: boolean
  isLastStep?: boolean
  onBackClick?: () => void
  onNextClick?: () => void
  disabledReason?: string
  nextButtonText?: string
}) => {
  if (!onBackClick && !onNextClick) {
    return null
  }

  return (
    <div className="flex w-full items-center justify-between">
      {onBackClick ? (
        <Button variant="secondary" onClick={onBackClick}>
          Back
        </Button>
      ) : (
        <div />
      )}
      <Button
        isDisabled={isDisabled}
        isLoading={isLoading}
        onClick={onNextClick}
        disabledReason={disabledReason}
      >
        {isLastStep ? 'Finish' : (nextButtonText ?? 'Continue')}
      </Button>
    </div>
  )
}
